import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import EmptyImg from '../assets/images/empty.png'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    img: {
      display: 'block',
      maxWidth: theme.spacing(20),
    },
  }),
)
const Loading = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Box display="flex" flexDirection="column" alignItems="center" my={4}>
      {props.status === 'pending' || !props.status ? (
        <CircularProgress color="primary" />
      ) : (
        <>
          <Typography component="div">
            <Box mb={2} fontSize="subtitle1.fontSize" color="grey.400">
              {props.title || t('tips.can_not_get_data')}
            </Box>
          </Typography>
          {!props.hideImg && <img className={classes.img} src={EmptyImg} alt="empty image" />}
        </>
      )}
    </Box>
  )
}

export default Loading
